module.exports = __webpack_public_path__ + "img/ai03.aff5779a.png";